// extracted by mini-css-extract-plugin
export default {"article":"Article_article__COgup","image":"Article_image__SGAP6","title":"Article_title__S+cgp","description":"Article_description__pvMSw","info":"Article_info__MphNa"};